import React from 'react';
import { KFLButton, KFLIcon } from '@kamstrup/kamstrup-frontend-library';
import EksKFLWrapper from '../eks-lib/eksKFLwrapper';
import Translate from '../localization/localize';
import * as DT from '../../../modules/datatable';
import Badge from '../badge';
import { AppKeys, MessageType, newMsg } from '../../../core/localization';
import Spinner from '../spinner';

interface OwnProps {
  dtState: DT.IDatatableState<any, any>;
  clearSelection: () => void;
  msgMain: string;
  msgExtra?: MessageType;
  editTableSettings?: () => void;
}
type Props = OwnProps;

const Summary: React.FC<Props> = (props) => {
  const { total } = props.dtState.data;
  const totalSelected = props.dtState.selection.selectedKeys.length;

  const msgFound = newMsg(AppKeys.Sum_Found);
  const msgTotal = newMsg(props.msgMain, [{ tag: 'count', value: total }]);
  const msgSelected = newMsg(AppKeys.Sum_Selected, [
    { tag: 'count', value: totalSelected },
  ]);
  const msgSearching = newMsg(AppKeys.Sum_Searching);

  return (
    <div className="layout__content__table_summary">
      <div className="summary_display">
        {props.dtState.data.total === 0 && props.dtState.table.isLoading ? (
          <Spinner mode="Horizontal" label={msgSearching} />
        ) : (
          <span>
            <strong>
              <Translate message={msgFound} /> <Translate message={msgTotal} />
            </strong>{' '}
            {totalSelected ? (
              <Badge primary onDismiss={props.clearSelection}>
                <Translate message={msgSelected} />
              </Badge>
            ) : (
              ''
            )}
          </span>
        )}
      </div>
      <div className="summary_actions">
        {props.editTableSettings && (
          <EksKFLWrapper>
            <KFLButton
              id="dt-edit-settings"
              onClick={props.editTableSettings}
              variant="secondary"
            >
              <KFLIcon name="Settings" size="sm" key="icon_settings" />
            </KFLButton>
          </EksKFLWrapper>
        )}
      </div>
    </div>
  );
};

export default Summary;
